module.exports = __webpack_public_path__ + "static/media/19.2499151f.jpeg";